import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useGetUsersWithoutRoleQuery, useSetProjectAdminMutation } from '../../../generated/graphql';
import { FormAutoComplete } from '../../form';
import styles from './NewProjectAdminDialog.module.css';

type NewProjectAdminDialogProps = {
    onClose: () => void,
    projectId: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewProjectAdminDialog = (props: NewProjectAdminDialogProps) => {
    const { style, visible, projectId, onClose } = props;
    const [searchUser, setSearchUser] = useState('');
    const [setProjectAdmin, setProjectAdminResult] = useSetProjectAdminMutation();
    const [validationError, setValidationError] = useState('');
    const users = useGetUsersWithoutRoleQuery({
        variables: { contains: searchUser }
    });

    const handleSubmit = () => {
        const selectedEmail = users.data?.UserList?.nodes?.filter(u => u?.email === searchUser)[0];
        if (!searchUser) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!selectedEmail) {
            setValidationError('Please Select A Valid Email!');
            return;
        }
        setValidationError('');
        setProjectAdmin({
            variables: { id: projectId, userId: selectedEmail?.id }
        })
            .then(() => onClose())
            .catch(() => {});
    };

    return (
        <DialogBase
            title="New Project Admin Dialog"
            type="OkCancel"
            isLoading={setProjectAdminResult.loading}
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.NewProjectAdminDialog}
            style={style}
            data-testid="NewProjectAdminDialog">
            <FormAutoComplete
                label="Email"
                name="email"
                value={searchUser}
                onChange={setSearchUser}
                options={(users.data?.UserList?.nodes?.map(c => c?.email) || []).filter((e): e is string => !!e)}
            />
        </DialogBase>
    );
};

export default NewProjectAdminDialog;